import React from 'react';
import { Link } from 'react-router-dom';

import Loader from 'components/Loader';
import PATHS from 'routes/paths';

import { insights as TEXT } from 'locales/en';
import { CURRENCY_SYMBOL } from 'utils/transform';

const RecentDonations = ({ isLoading, data }) => {
  return (
    <div className="border-b lg:border-b-0 lg:border-r border-javelin-gray-border p-5 lg:p-7 flex flex-col relative min-h-28 h-auto">
      {isLoading ? (
        <Loader
          isBarVisible={false}
          fullScreen={false}
          className="justify-center items-center -mt-14"
        />
      ) : (
        <>
          <p className="mb-4 text-sm text-javelin-gray-dark text-opacity-40">
            {TEXT.donations.recent}
          </p>
          {!!data.length ? (
            <>
              {data.map((donation, idx) => (
                <div key={donation.id} className="text-sm h-8 flex flex-row">
                  <span className="w-24 lg:min-w-32 lg:w-auto truncate mr-1">
                    {donation.shopper_name} {donation.shopper_surname}
                  </span>
                  <span className="w-24 truncate font-bold min-w-16 lg:min-w-28 lg:w-auto mr-1">
                    {CURRENCY_SYMBOL.EUR}
                    {donation.total}
                  </span>
                  <span className="w-auto truncate">{donation.storeName}</span>
                </div>
              ))}
              <Link
                to={PATHS.orders}
                className="text-xs underline text-javelin-gray-light place-self-end mt-auto"
              >
                {TEXT.donations.view}
              </Link>
            </>
          ) : (
            [0, 1, 2].map((item) => (
              <p key={item} className="text-sm text-javelin-gray-dark mb-3">
                -
              </p>
            ))
          )}
        </>
      )}
    </div>
  );
};

export default RecentDonations;
